import React, { useState, Suspense, lazy, useEffect, useRef } from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import api from './api';
import './App.css';
import { ThemeProvider } from './ThemeContext';
import useResponsive from './hooks/useResponsive';
import IhaleTakip from './pages/IhaleTakip';
import IhaleDetay from './pages/IhaleDetay';
import IhaleArac  from './pages/IhaleArac';
import TTSLogin   from './pages/TTSLogin';
import TTSOnay    from './pages/TTSOnay';
import TTSHakedis from './pages/TTSHakedis';
import AcilParcaSiparis from './pages/AcilParcaSiparis';
import MobilePreviewRoute from './previews/MobilePreviewRoute';
import DashboardPreview from './previews/DashboardPreview';
import { initWebPushSubscription } from './utils/webPush';
import RandevuOzetModal from './components/RandevuOzetModal';
const Teklifler = lazy(() => import('./pages/Teklifler'));
const Bildirimler = lazy(() => import('./pages/Bildirimler'));
const Uygulamalar = lazy(() => import('./pages/Uygulamalar'));
const ZihinMolasi = lazy(() => import('./pages/ZihinMolasi'));
const PuzzleGuest = lazy(() => import('./pages/PuzzleGuest'));
const TruckParking = lazy(() => import('./pages/TruckParking'));

const Login = lazy(() => import('./pages/Login'));
const Lokasyon = lazy(() => import('./pages/Lokasyon'));
const AracListesi = lazy(() => import('./pages/AracListesi'));
const AracDosyasi = lazy(() => import('./pages/AracDosyasi'));
const YeniArac = lazy(() => import('./pages/YeniArac'));
const Muhasebe = lazy(() => import('./pages/Muhasebe'));
const Admin = lazy(() => import('./pages/Admin'));
const Arsiv = lazy(() => import('./pages/Arsiv'));
const Mesajlar = lazy(() => import('./pages/Mesajlar'));
const SatinAlma = lazy(() => import('./pages/SatinAlma'));
const Finans = lazy(() => import('./pages/Finans'));
const IK = lazy(() => import('./pages/IK'));
const Pazarlama = lazy(() => import('./pages/Pazarlama'));
const OtoParts = lazy(() => import('./pages/OtoParts'));
const KaportaRaporOrnek = lazy(() => import('./pages/KaportaRaporOrnek'));
const BelgeTalepPublic = lazy(() => import('./pages/BelgeTalepPublic'));
const MusteriDosya = lazy(() => import('./pages/MusteriDosya'));
const CariBilgiler = lazy(() => import('./pages/CariBilgiler'));
const VehicleListPreview = lazy(() => import('./previews/VehicleListPreview'));
const VehicleDetailPreview = lazy(() => import('./previews/VehicleDetailPreview'));

const createDefaultNavSnapshot = () => {
  const params = new URLSearchParams(window.location.search || '');
  return {
    sayfa: params.get('sayfa') || 'lokasyon',
    secilenLok: params.get('lokasyon') || null,
    secilenArac: null,
    secilenAracTab: null,
    secilenIhale: null,
    secilenIhaleArac: null,
  };
};

function MobileMenuLauncher({ open, onToggle, bildirimSayi = 0 }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={open ? 'Menüyü kapat' : 'Menüyü aç'}
      aria-expanded={open}
      style={mobileMenuLauncher(open)}
    >
      <span style={{ fontSize: 22, lineHeight: 1 }}>{open ? '×' : '☰'}</span>
      <span style={mobileMenuLauncherLabel()}>{open ? 'Kapat' : 'Menü'}</span>
      {!open && bildirimSayi > 0 && (
        <span style={mobileMenuLauncherBadge()}>{bildirimSayi > 99 ? '99+' : bildirimSayi}</span>
      )}
    </button>
  );
}

function MobileQuickActions({ open, onClose, primaryItems, activeKey, items, kullanici }) {
  if (!open) return null;

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', zIndex: 10030 }}
      />
      <div style={mobileSheetWrap()} role="dialog" aria-modal="true" aria-label="Hızlı erişim menüsü">
        <div style={mobileSheetCard()}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 16 }}>
            <div>
              <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 12, fontWeight: 800, letterSpacing: 1.4, textTransform: 'uppercase', color: 'var(--muted)' }}>
                Hızlı Erişim
              </div>
              <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 24, fontWeight: 900, color: 'var(--ink)' }}>
                {kullanici?.ad_soyad || kullanici?.kullanici_adi}
              </div>
            </div>
            <button onClick={onClose} style={mobileCloseBtn()}>Kapat</button>
          </div>

          <div style={mobilePrimaryActions()}>
            {primaryItems.map((item) => {
              const aktif = activeKey === item.key;
              return (
                <button
                  key={item.key}
                  onClick={() => {
                    onClose();
                    item.onClick();
                  }}
                  style={mobilePrimaryActionBtn(aktif)}
                >
                  <span style={{ fontSize: 19, lineHeight: 1 }}>{item.icon}</span>
                  <span style={mobilePrimaryActionLabel(aktif)}>{item.label}</span>
                  {item.badge > 0 && <span style={mobileBadge()}>{item.badge > 99 ? '99+' : item.badge}</span>}
                </button>
              );
            })}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {items.map((item) => (
              <button
                key={item.key}
                onClick={() => {
                  onClose();
                  item.onClick();
                }}
                style={mobileActionBtn()}
              >
                <span style={{ fontSize: 22 }}>{item.icon}</span>
                <span style={{ display: 'grid', gap: 2 }}>
                  <span style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 15, fontWeight: 800, color: 'var(--ink)', textAlign: 'left' }}>
                    {item.label}
                  </span>
                  <span style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'left' }}>
                    {item.hint}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── İÇ APP (AuthContext'e erişimli) ─────────────────── */
function AppIci() {
  const { kullanici, cikisYap, canGor, canDuzenle } = useAuth();
  const { isMobile } = useResponsive();
  const rolKod = String(kullanici?.rol_kod || kullanici?.rol || '').trim().toLocaleLowerCase('tr-TR');
  const eksperKullanici = rolKod === 'eksper';
  const initialNavRef = useRef(window.history.state?.otoflowNav || createDefaultNavSnapshot());
  const navigationRef = useRef(initialNavRef.current);
  const initialNav = initialNavRef.current;

  const [sayfa, setSayfa]           = useState(initialNav.sayfa || 'lokasyon');
  const [secilenLok, setSecilenLok] = useState(initialNav.secilenLok || null);
  const [secilenArac, setSecilenArac] = useState(initialNav.secilenArac || null);
  const [secilenAracTab, setSecilenAracTab] = useState(initialNav.secilenAracTab || null);
  const [okunmamisSayi, setOkunmamisSayi] = useState(0);
  const [bildirimDrawer, setBildirimDrawer] = useState(false);
  const [bildirimSayi, setBildirimSayi] = useState(0);
  const [secilenIhale, setSecilenIhale] = useState(initialNav.secilenIhale || null);
  const [secilenIhaleArac, setSecilenIhaleArac] = useState(initialNav.secilenIhaleArac || null);
  const [mobilMenuAcik, setMobilMenuAcik] = useState(false);
  const [satinalmaAcilisSekme, setSatinalmaAcilisSekme] = useState(null);
  const [randevuOzet, setRandevuOzet] = useState(null);
  const [randevuOzetAcik, setRandevuOzetAcik] = useState(false);

  const buildSnapshot = (overrides = {}) => ({
    sayfa: overrides.sayfa ?? navigationRef.current.sayfa ?? 'lokasyon',
    secilenLok: Object.prototype.hasOwnProperty.call(overrides, 'secilenLok')
      ? overrides.secilenLok
      : (navigationRef.current.secilenLok ?? null),
    secilenArac: Object.prototype.hasOwnProperty.call(overrides, 'secilenArac')
      ? overrides.secilenArac
      : (navigationRef.current.secilenArac ?? null),
    secilenAracTab: Object.prototype.hasOwnProperty.call(overrides, 'secilenAracTab')
      ? overrides.secilenAracTab
      : (
        Object.prototype.hasOwnProperty.call(overrides, 'secilenArac')
          ? (overrides.secilenArac ? (navigationRef.current.secilenAracTab ?? null) : null)
          : (navigationRef.current.secilenAracTab ?? null)
      ),
    secilenIhale: Object.prototype.hasOwnProperty.call(overrides, 'secilenIhale')
      ? overrides.secilenIhale
      : (navigationRef.current.secilenIhale ?? null),
    secilenIhaleArac: Object.prototype.hasOwnProperty.call(overrides, 'secilenIhaleArac')
      ? overrides.secilenIhaleArac
      : (navigationRef.current.secilenIhaleArac ?? null),
  });

  const applySnapshot = (snapshot) => {
    setSayfa(snapshot.sayfa || 'lokasyon');
    setSecilenLok(snapshot.secilenLok ?? null);
    setSecilenArac(snapshot.secilenArac ?? null);
    setSecilenAracTab(snapshot.secilenAracTab ?? null);
    setSecilenIhale(snapshot.secilenIhale ?? null);
    setSecilenIhaleArac(snapshot.secilenIhaleArac ?? null);
  };

  const syncHistory = (snapshot, mode = 'push') => {
    const params = new URLSearchParams();
    if (snapshot.sayfa && snapshot.sayfa !== 'lokasyon') params.set('sayfa', snapshot.sayfa);
    if (snapshot.secilenLok) params.set('lokasyon', snapshot.secilenLok);
    // Keep a validated web-inbox deep link through the initial navigation sync.
    const currentQuery = new URLSearchParams(window.location.search);
    if (snapshot.sayfa === 'pazarlama' && currentQuery.get('sekme') === 'site-yonetimi') params.set('sekme', 'site-yonetimi');
    if (snapshot.sayfa === 'ik') {
      const application = currentQuery.get('basvuru') || '';
      if (/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(application)) params.set('basvuru', application);
    }
    if (snapshot.sayfa === 'mesajlar' && currentQuery.get('kanal') === 'web') {
      params.set('kanal', 'web');
      const conversation = currentQuery.get('gorusme') || '';
      if (/^[0-9a-f-]{36}$/i.test(conversation)) params.set('gorusme', conversation);
    }
    const query = params.toString();
    const url = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    const state = { ...(window.history.state || {}), otoflowNav: snapshot };
    if (mode === 'replace') window.history.replaceState(state, '', url);
    else window.history.pushState(state, '', url);
  };

  const navigate = (overrides, options = {}) => {
    const snapshot = buildSnapshot(overrides);
    applySnapshot(snapshot);
    setMobilMenuAcik(false);
    setBildirimDrawer(false);
    syncHistory(snapshot, options.mode || 'push');
  };

  useEffect(() => {
    navigationRef.current = { sayfa, secilenLok, secilenArac, secilenAracTab, secilenIhale, secilenIhaleArac };
  }, [sayfa, secilenLok, secilenArac, secilenAracTab, secilenIhale, secilenIhaleArac]);

  useEffect(() => {
    syncHistory(initialNav, 'replace');
    const onPopState = (event) => {
      applySnapshot(event.state?.otoflowNav || createDefaultNavSnapshot());
      setBildirimDrawer(false);
      setMobilMenuAcik(false);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [initialNav]);

  useEffect(() => {
    const mobileShell = isMobile && !!kullanici;
    document.body.classList.toggle('otoflow-mobile-shell', mobileShell);
    document.documentElement.style.setProperty(
      '--mobile-app-bottom-offset',
      mobileShell ? 'calc(82px + env(safe-area-inset-bottom, 0px))' : '0px'
    );
    return () => {
      document.body.classList.remove('otoflow-mobile-shell');
      document.documentElement.style.setProperty('--mobile-app-bottom-offset', '0px');
    };
  }, [isMobile, kullanici]);

  useEffect(() => {
    if (!isMobile || !mobilMenuAcik) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isMobile, mobilMenuAcik]);

  // Her yeni oturumda bugünün ve içinde bulunulan haftanın randevularını göster.
  useEffect(() => {
    if (!kullanici?.id) return;
    let aktif = true;
    api.get('/randevular/ozet')
      .then(({ data }) => {
        if (!aktif) return;
        setRandevuOzet(data || { bugun: [], hafta: [] });
        setRandevuOzetAcik(data?.goster !== false);
      })
      .catch(() => {
        if (aktif) setRandevuOzetAcik(false);
      });
    return () => { aktif = false; };
  }, [kullanici?.id]);

  useEffect(() => {
    // Custom CSS uygula
    api.get('/ayarlar/css').then(({ data }) => {
      if (data.deger) {
        let styleEl = document.getElementById('custom-css-style');
        if (!styleEl) { styleEl = document.createElement('style'); styleEl.id = 'custom-css-style'; document.head.appendChild(styleEl); }
        styleEl.textContent = data.deger;
      }
    }).catch(() => {});
  }, [kullanici?.id]);

  useEffect(() => {
    if (!kullanici) return;
    if (eksperKullanici) {
      setBildirimSayi(0);
      return;
    }
    let aktif = true;
    const yukle = async () => {
      if (document.hidden) return;
      try {
        const { data } = await api.get('/mesajlar/okunmamis');
        if (aktif) setOkunmamisSayi(Number(data.toplam || 0));
      } catch {}
    };
    yukle();
    const id = setInterval(yukle, 4000);
    const onVisibility = () => {
      if (!document.hidden) yukle();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      aktif = false;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [kullanici?.id, eksperKullanici]);

  useEffect(() => {
    if (!kullanici?.id) return;
    const timer = setTimeout(() => {
      initWebPushSubscription().catch(() => {});
    }, 1200);
    return () => clearTimeout(timer);
  }, [kullanici?.id]);

  useEffect(() => {
    if (!kullanici) return;
    let aktif = true;
    const yukle = async () => {
      if (document.hidden) return;
      try {
        const { data } = await api.get('/bildirimler/okunmamis-sayi');
        if (aktif) setBildirimSayi(Number(data.toplam || 0));
      } catch {}
    };
    yukle();
    const id = setInterval(yukle, 15000);
    const onVisibility = () => {
      if (!document.hidden) yukle();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      aktif = false;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [kullanici?.id]);

  // /tts — onay mercii ve hakediş portalı
  if (window.location.pathname === '/tts' || window.location.pathname.startsWith('/tts')) {
    const ttsRoller = ['onay_mercii', 'hakedis', 'frenusta', 'yonetici'];
    if (!kullanici || !ttsRoller.includes(kullanici.rol)) {
      return <TTSLogin />;
    }
    if (kullanici.rol === 'onay_mercii') return <TTSOnay kullanici={kullanici} cikisYap={cikisYap} />;
    if (kullanici.rol === 'hakedis')     return <TTSHakedis kullanici={kullanici} cikisYap={cikisYap} />;
    // yönetici ve frenusta /tts'e girerse normal ihale sayfasına yönlendir
    window.location.href = '/';
    return null;
  }

  // /otoparts — tedarikçi portalı, login gerektirmez
  if (window.location.pathname === '/otoparts' || window.location.pathname.startsWith('/otoparts')) {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <OtoParts />
      </Suspense>
    );
  }

  // /belge-talep/:token — dış yetkili belge yükleme sayfası (login gerektirmez)
  if (window.location.pathname.startsWith('/belge-talep/')) {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <BelgeTalepPublic />
      </Suspense>
    );
  }

  if (!kullanici) {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Login />
      </Suspense>
    );
  }

  // Yönetici yetkisi kontrolü
  const adminGorebilir = !eksperKullanici && (kullanici?.rol === 'yonetici' || canGor('kullanicilar') || canGor('roller'));

  // Global butonlar - sabit konumda, her sayfada görünür
  const GlobalButonlar = !isMobile && sayfa !== 'mesajlar' && sayfa !== 'bildirimler' ? (
    <div style={{
      position:'fixed',
      bottom:isMobile ? 14 : 24,
      right:isMobile ? 14 : 24,
      zIndex:9999,
      display:'flex',
      flexDirection:'column',
      gap:isMobile ? 8 : 10,
      alignItems:'flex-end',
    }}>
      {adminGorebilir && sayfa !== 'admin' && (
        <button
          onClick={() => navigate({ sayfa: 'admin', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          style={{
            background:'var(--ink)',color:'white',border:'none',borderRadius:50,
            width:isMobile ? 40 : 44,height:isMobile ? 40 : 44,fontSize:16,cursor:'pointer',
            boxShadow:'0 4px 16px rgba(0,0,0,.25)',
            display:'flex',alignItems:'center',justifyContent:'center',
          }}
          title="Admin"
        >⚙️</button>
      )}
      {!eksperKullanici && (
        <button
          onClick={() => setBildirimDrawer(true)}
          style={{
            background:'var(--surface)',color:'var(--ink)',border:'1px solid var(--border2)',borderRadius:50,
            width:isMobile ? 40 : 44,height:isMobile ? 40 : 44,fontSize:18,cursor:'pointer',
            boxShadow:'0 4px 16px rgba(0,0,0,.15)',
            display:'flex',alignItems:'center',justifyContent:'center',
            position:'relative',
          }}
          title="Bildirimler"
        >
          🔔
          {bildirimSayi > 0 && (
            <span style={{
              position:'absolute',top:-4,right:-4,
              minWidth:18,height:18,borderRadius:9,padding:'0 5px',
              background:'#e74c3c',color:'white',fontSize:10,fontWeight:800,
              display:'flex',alignItems:'center',justifyContent:'center',
              fontFamily:"'Barlow Condensed',sans-serif",
            }}>{bildirimSayi > 99 ? '99+' : bildirimSayi}</span>
          )}
        </button>
      )}
      <button
        onClick={() => navigate({ sayfa: 'mesajlar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
        style={{
          background:'var(--blue)',color:'white',border:'none',borderRadius:50,
          width:isMobile ? 46 : 52,height:isMobile ? 46 : 52,fontSize:20,cursor:'pointer',
          boxShadow:'0 4px 16px rgba(0,0,0,.25)',
          display:'flex',alignItems:'center',justifyContent:'center',
          position:'relative',
        }}
        title="Mesajlar"
      >
        💬
        {okunmamisSayi > 0 && (
          <span style={{
            position:'absolute',top:-4,right:-4,
            minWidth:18,height:18,borderRadius:9,padding:'0 5px',
            background:'#e74c3c',color:'white',fontSize:10,fontWeight:800,
            display:'flex',alignItems:'center',justifyContent:'center',
            fontFamily:"'Barlow Condensed',sans-serif",
          }}>{okunmamisSayi}</span>
        )}
      </button>
    </div>
  ) : null;

  // Eski MesajlarBtn alias - geriye uyumluluk
  const MesajlarBtn = GlobalButonlar;

  // Bildirim Drawer
  const BildirimDrawer = !isMobile && bildirimDrawer ? (
    <>
      {/* Overlay */}
      <div onClick={() => setBildirimDrawer(false)}
        style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.3)', zIndex:9998 }} />
      {/* Panel */}
      <div style={{
        position:'fixed', top:0, right:0, bottom:0, width:isMobile ? '100vw' : 'min(480px,95vw)',
        background:'var(--surface)', boxShadow:'-8px 0 32px rgba(0,0,0,.15)',
        zIndex:9999, overflow:'auto', display:'flex', flexDirection:'column',
      }}>
        <Suspense fallback={<div style={{padding:40,textAlign:'center',color:'var(--muted)'}}>Yükleniyor...</div>}>
          <Bildirimler
            drawer={true}
            okunmamisSayi={bildirimSayi}
            onGeriDon={() => setBildirimDrawer(false)}
            onBildirimAc={async (b, options = {}) => {
              if (b.hedef_tip === 'arac' && b.hedef_id) {
                setBildirimDrawer(false);
                try {
                  const { data } = await api.get(`/araclar/${b.hedef_id}`);
                  if (data) aracAc(data);
                } catch {}
              }
              if (options.okunduyaCevir !== false) {
                setBildirimSayi((s) => Math.max(0, s - 1));
              }
            }}
            onBildirimSilindi={() => {
              setBildirimSayi((s) => Math.max(0, s - 1));
            }}
          />
        </Suspense>
      </div>
    </>
  ) : null;

  const lokasyonSec = lok => {
    navigate({
      sayfa: 'liste',
      secilenLok: lok,
      secilenArac: null,
      secilenAracTab: null,
      secilenIhale: null,
      secilenIhaleArac: null,
    });
  };

  const aracAc = arac => {
    if (arac === 'yeni') {
      navigate({
        sayfa: 'yeniArac',
        secilenArac: null,
        secilenAracTab: null,
        secilenIhale: null,
        secilenIhaleArac: null,
      });
    } else {
      navigate({
        sayfa: 'dosya',
        secilenArac: arac,
        secilenAracTab: null,
        secilenIhale: null,
        secilenIhaleArac: null,
      });
      // Araç açıldığında bildirim tetikle
      if (arac?.id) {
        api.post('/bildirimler/olay/arac-acildi', { arac_id: arac.id }).catch(() => {});
      }
    }
  };

  const RandevuOzetPopup = randevuOzetAcik ? (
    <RandevuOzetModal
      ozet={randevuOzet}
      onClose={() => setRandevuOzetAcik(false)}
      onAracAc={async (randevu) => {
        if (!randevu?.arac_id) return;
        try {
          const { data } = await api.get(`/araclar/${randevu.arac_id}`);
          if (data) {
            setRandevuOzetAcik(false);
            aracAc(data);
          }
        } catch {}
      }}
    />
  ) : null;

  const tekliftenIsEmriAc = async ({ aracId, lokasyon, arac }) => {
    const hedefLokasyon = ['ikitelli', 'hadimkoy'].includes(String(lokasyon || '').toLowerCase())
      ? String(lokasyon).toLowerCase()
      : (secilenLok || kullanici?.lokasyon || 'ikitelli');
    let aracDetay = arac;
    if ((!aracDetay || !aracDetay.id) && aracId) {
      try {
        const { data } = await api.get(`/araclar/${aracId}`);
        aracDetay = data || null;
      } catch {
        aracDetay = null;
      }
    }
    if (!aracDetay?.id) return;
    navigate({
      sayfa: 'dosya',
      secilenLok: hedefLokasyon,
      secilenArac: aracDetay,
      secilenAracTab: null,
      secilenIhale: null,
      secilenIhaleArac: null,
    });
  };

  const sigortaBasvurudanEksperAc = async (arac) => {
    if (!arac?.id) return;
    try {
      const { data } = await api.get(`/araclar/${arac.id}`);
      if (!data) return;
      navigate({
        sayfa: 'dosya',
        secilenArac: data,
        secilenAracTab: 'eksper',
        secilenIhale: null,
        secilenIhaleArac: null,
      });
    } catch {}
  };

  const listeyeDon = () => {
    navigate({
      sayfa: 'liste',
      secilenArac: null,
      secilenAracTab: null,
      secilenIhale: null,
      secilenIhaleArac: null,
    });
  };

  const menuyeDon = () => {
    navigate({
      sayfa: 'lokasyon',
      secilenLok: null,
      secilenArac: null,
      secilenAracTab: null,
      secilenIhale: null,
      secilenIhaleArac: null,
    });
  };

  const satinAlmayaGit = (sekme = null) => {
    setSatinalmaAcilisSekme(sekme || null);
    navigate({
      sayfa: 'satinalma',
      secilenArac: null,
      secilenAracTab: null,
      secilenIhale: null,
      secilenIhaleArac: null,
    });
  };

  const mobilBirincilSayfa = (() => {
    if (sayfa === 'mesajlar') return 'mesajlar';
    if (!eksperKullanici && sayfa === 'bildirimler') return 'bildirimler';
    if (sayfa === 'satinalma' || sayfa === 'teklifler' || sayfa === 'acilParca') return 'operasyon';
    if (sayfa === 'ihale' || sayfa === 'ihaleDetay' || sayfa === 'ihaleArac') return 'ihale';
    return 'ana';
  })();

  const mobilAnaSekmeler = [
    {
      key: 'ana',
      label: 'Ana',
      icon: '🏠',
      onClick: menuyeDon,
    },
    {
      key: 'mesajlar',
      label: 'Mesajlar',
      icon: '💬',
      badge: okunmamisSayi,
      onClick: () => navigate({ sayfa: 'mesajlar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }),
    },
    !eksperKullanici && {
      key: 'bildirimler',
      label: 'Bildirim',
      icon: '🔔',
      badge: bildirimSayi,
      onClick: () => navigate({ sayfa: 'bildirimler', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }),
    },
    {
      key: canGor('satinalma') ? 'operasyon' : 'ihale',
      label: canGor('satinalma') ? 'Operasyon' : 'Ihale',
      icon: canGor('satinalma') ? '🧾' : '📋',
      onClick: () => {
        if (canGor('satinalma')) satinAlmayaGit();
        else navigate({
          sayfa: 'ihale',
          secilenArac: null,
          secilenIhale: null,
          secilenIhaleArac: null,
        });
      },
    },
  ].filter(Boolean);
  const cariGorunur = !eksperKullanici && (kullanici?.rol === 'yonetici' || canGor('lokasyon') || canGor('muhasebe') || canGor('finans') || canGor('arsiv'));

  const mobilHizliAksiyonlar = [
    { key: 'liste', label: 'Araclar', icon: '🚛', hint: 'Lokasyondaki araclari ac', onClick: () => navigate({ sayfa: 'liste', secilenLok: secilenLok || kullanici?.lokasyon || null, secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    (kullanici?.rol === 'yonetici') && { key: 'sigortaBasvuru', label: 'Sigorta Başvuru', icon: '🟢', hint: 'Dosya açılışı bekleyen araçlar', onClick: () => navigate({ sayfa: 'sigortaBasvuru', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    canGor('satinalma') && { key: 'satinalma', label: 'Satın Alma', icon: '🧾', hint: 'Siparis ve onay akislari', onClick: () => satinAlmayaGit() },
    (canGor('teklif_gor') || canGor('teklif_ver') || kullanici?.rol === 'yonetici') && { key: 'teklifler', label: 'Raporlar ve Belgeler', icon: '📝', hint: 'Teklif, rapor ve resmi belge oluştur', onClick: () => navigate({ sayfa: 'teklifler', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    canGor('ihale') && { key: 'ihale', label: 'Ihale Takip', icon: '📋', hint: 'TTS ve ihale operasyonu', onClick: () => navigate({ sayfa: 'ihale', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    canGor('muhasebe') && { key: 'muhasebe', label: 'Muhasebe', icon: '📊', hint: 'Fatura ve dosya akislari', onClick: () => navigate({ sayfa: 'muhasebe', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    canGor('finans') && { key: 'finans', label: 'Finans', icon: '💰', hint: 'Havale ve odeme takibi', onClick: () => navigate({ sayfa: 'finans', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    (kullanici?.rol === 'yonetici') && { key:'ik',label:'İnsan Kaynakları',icon:'👥',hint:'İş ilanları ve başvurular',onClick:()=>navigate({sayfa:'ik',secilenArac:null}) },
    canGor('pazarlama') && { key: 'pazarlama', label: 'Pazarlama', icon: '📣', hint: 'Firma ve kampanya merkezi', onClick: () => navigate({ sayfa: 'pazarlama', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    cariGorunur && { key: 'cari', label: 'Musteriler', icon: '👥', hint: 'Firma kartlari ve filo listesi', onClick: () => navigate({ sayfa: 'cari', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    canGor('arsiv') && { key: 'arsiv', label: 'Arsiv', icon: '📦', hint: 'Kapatilan dosyalar', onClick: () => navigate({ sayfa: 'arsiv', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    (canGor('siparis_ver') || canGor('satinalma')) && { key: 'acilParca', label: 'Acil Parca', icon: '⚡', hint: 'Hizli siparis olustur', onClick: () => navigate({ sayfa: 'acilParca', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    { key: 'uygulamalar', label: 'Uygulamalar', icon: '✦', hint: 'PhotoCraft ve ofis araçları', onClick: () => navigate({ sayfa: 'uygulamalar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
    (canGor('kullanicilar') || kullanici?.rol === 'yonetici') && !eksperKullanici && { key: 'admin', label: 'Admin', icon: '⚙️', hint: 'Yonetim ayarlari', onClick: () => navigate({ sayfa: 'admin', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }) },
  ].filter(Boolean);

  const MobilChrome = isMobile ? (
    <>
      <MobileQuickActions
        open={mobilMenuAcik}
        onClose={() => setMobilMenuAcik(false)}
        primaryItems={mobilAnaSekmeler}
        activeKey={mobilBirincilSayfa}
        items={mobilHizliAksiyonlar}
        kullanici={kullanici}
      />
      <MobileMenuLauncher
        open={mobilMenuAcik}
        onToggle={() => setMobilMenuAcik((acik) => !acik)}
        bildirimSayi={bildirimSayi}
      />
    </>
  ) : null;

  if (sayfa === 'lokasyon') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Lokasyon
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onLokasyonSec={lokasyonSec}
          onMuhasebe={() => navigate({ sayfa: 'muhasebe', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onArsiv={() => navigate({ sayfa: 'arsiv', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onSatinAlma={(sekme) => satinAlmayaGit(sekme)}
          onFinans={() => navigate({ sayfa: 'finans', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onIK={() => navigate({sayfa:'ik',secilenArac:null})}
          onPazarlama={() => navigate({ sayfa: 'pazarlama', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onAdmin={() => navigate({ sayfa: 'admin', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onSigortaBasvuru={() => navigate({ sayfa: 'sigortaBasvuru', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onIhaleTakip={() => navigate({ sayfa: 'ihale', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onTeklifler={() => navigate({ sayfa: 'teklifler', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onCari={() => navigate({ sayfa: 'cari', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onAcilParca={() => navigate({ sayfa: 'acilParca', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onUygulamalar={() => navigate({ sayfa: 'uygulamalar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          onCikis={cikisYap}
        />
        {MesajlarBtn}{BildirimDrawer}
        {RandevuOzetPopup}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'uygulamalar') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Uygulamalar onGeriDon={menuyeDon} onZihinMolasi={() => navigate({ sayfa: 'zihinMolasi', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })} onTruckParking={() => navigate({ sayfa: 'tirPark', secilenArac: null })} />
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'tirPark') {
    return <Suspense fallback={<div style={{background:'#142328',color:'#efb860',padding:40,minHeight:'100vh'}}>Park sahası hazırlanıyor…</div>}><TruckParking key={kullanici.id || kullanici.kullanici_adi} userId={kullanici.id || kullanici.kullanici_adi} userName={kullanici.kul_adi || kullanici.kullanici_adi} onGeriDon={() => navigate({ sayfa: 'uygulamalar' })} />{MobilChrome}</Suspense>;
  }

  if (sayfa === 'zihinMolasi') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <ZihinMolasi key={kullanici.id || kullanici.kullanici_adi} userId={kullanici.id || kullanici.kullanici_adi} userName={kullanici.kul_adi || kullanici.kullanici_adi}
          onGeriDon={() => navigate({ sayfa: 'uygulamalar' })} />
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'sigortaBasvuru') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <AracListesi
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          lokasyon={secilenLok || kullanici.lokasyon}
          onAracAc={aracAc}
          onSigortaBasvuruAcildi={sigortaBasvurudanEksperAc}
          onGeriDon={menuyeDon}
          onMesajlar={() => navigate({ sayfa: 'mesajlar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
          okunmamisSayi={okunmamisSayi}
          mode="sigorta_basvuru"
        />
        {MesajlarBtn}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'arsiv') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Arsiv
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeriDon={menuyeDon}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'cari') {
    if (eksperKullanici) {
      return (
        <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Barlow Condensed',sans-serif", color:'var(--muted)' }}>
          Bu sayfaya erişim yetkiniz yok.
        </div>
      );
    }
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <CariBilgiler
          kullanici={kullanici}
          canDuzenle={canDuzenle}
          onGeriDon={menuyeDon}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'admin' && !adminGorebilir) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Barlow Condensed',sans-serif", color:'var(--muted)' }}>
        Bu sayfaya erişim yetkiniz yok.
      </div>
    );
  }

  if (sayfa === 'admin') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Admin
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeriDon={menuyeDon}
          onNavigate={id => {
            if (id === 'liste') menuyeDon();
            else if (id === 'muhasebe') navigate({ sayfa: 'muhasebe', secilenArac: null, secilenIhale: null, secilenIhaleArac: null });
          }}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'muhasebe') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Muhasebe
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeriDon={menuyeDon}
          onAracAc={aracAc}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'satinalma') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <SatinAlma
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          acilisSekme={satinalmaAcilisSekme}
          onGeriDon={menuyeDon}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'acilParca') {
    return (
      <>
        <AcilParcaSiparis
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeri={menuyeDon}
        />
        {MobilChrome}
      </>
    );
  }

  if (sayfa === 'finans') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Finans
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeriDon={menuyeDon}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'ik') {
    return <Suspense fallback={<div style={{padding:40}}>İK yükleniyor…</div>}><IK kullanici={kullanici} onGeriDon={menuyeDon}/>{MesajlarBtn}{BildirimDrawer}{MobilChrome}</Suspense>;
  }

  if (sayfa === 'pazarlama') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Pazarlama kullanici={kullanici} canGor={canGor} canDuzenle={canDuzenle} onGeriDon={menuyeDon} />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'kaportaRaporOrnek') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <KaportaRaporOrnek
          onGeriDon={menuyeDon}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'yeniArac') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <YeniArac
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          lokasyon={secilenLok}
          onGeriDon={listeyeDon}
          onKaydet={yeniArac => {
            const hasarTuru = String(yeniArac?.hasar_turu || yeniArac?.hasarTuru || '').toLowerCase();
            if (['kasko', 'trafik'].includes(hasarTuru)) {
              navigate({
                sayfa: 'sigortaBasvuru',
                secilenLok: yeniArac?.lokasyon || secilenLok || kullanici?.lokasyon || null,
                secilenArac: null,
                secilenIhale: null,
                secilenIhaleArac: null,
              });
            } else {
              navigate({
                sayfa: 'dosya',
                secilenArac: yeniArac,
                secilenAracTab: null,
                secilenIhale: null,
                secilenIhaleArac: null,
              });
            }
          }}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'dosya' && secilenArac) {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <AracDosyasi
          arac={secilenArac}
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeriDon={listeyeDon}
          onMesajlar={() => navigate({ sayfa: 'mesajlar', secilenArac: null })}
          okunmamisSayi={okunmamisSayi}
          baslangicTab={secilenAracTab}
        />
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'bildirimler') {
    if (eksperKullanici) {
      navigate({ sayfa: 'mesajlar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null }, { mode: 'replace' });
      return null;
    }
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Bildirimler
          okunmamisSayi={bildirimSayi}
          onGeriDon={menuyeDon}
          onBildirimAc={async (b, options = {}) => {
            if (b.hedef_tip === 'arac' && b.hedef_id) {
              try {
                const { data } = await api.get(`/araclar/${b.hedef_id}`);
                if (data) aracAc(data);
              } catch {}
            }
            if (options.okunduyaCevir !== false) {
              setBildirimSayi((s) => Math.max(0, s - 1));
            }
          }}
          onBildirimSilindi={() => {
            setBildirimSayi((s) => Math.max(0, s - 1));
          }}
        />
        {isMobile ? null : MesajlarBtn}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'mesajlar') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Mesajlar
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          canGorCheck={canGor}
          setSayfa={(hedef) => {
            if (hedef === 'muhasebe') navigate({ sayfa: 'muhasebe', secilenArac: null, secilenIhale: null, secilenIhaleArac: null });
            else if (hedef === 'satinalma') satinAlmayaGit();
            else if (hedef === 'finans') navigate({ sayfa: 'finans', secilenArac: null, secilenIhale: null, secilenIhaleArac: null });
            else if (hedef === 'ikitelli') navigate({ sayfa: 'liste', secilenLok: 'ikitelli', secilenArac: null, secilenIhale: null, secilenIhaleArac: null });
            else if (hedef === 'hadimkoy') navigate({ sayfa: 'liste', secilenLok: 'hadimkoy', secilenArac: null, secilenIhale: null, secilenIhaleArac: null });
            else menuyeDon();
          }}
          onGeriDon={menuyeDon}
        />
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'ihaleArac' && secilenIhaleArac) {
    return (
      <>
        <IhaleArac
          arac={secilenIhaleArac.arac}
          ihale={secilenIhaleArac.ihale}
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeri={() => navigate({
            sayfa: 'ihaleDetay',
            secilenIhale: secilenIhaleArac.ihale,
            secilenIhaleArac: null,
          })}
        />
        {MobilChrome}
      </>
    );
  }

  if (sayfa === 'ihaleDetay' && secilenIhale) {
    return (
      <>
        <IhaleDetay
          ihale={secilenIhale}
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeri={() => navigate({ sayfa: 'ihale', secilenIhale: null, secilenIhaleArac: null })}
          onAracDetay={(arac, ihale) => navigate({
            sayfa: 'ihaleArac',
            secilenIhale: ihale,
            secilenIhaleArac: { arac, ihale },
          })}
        />
        {MobilChrome}
      </>
    );
  }

  if (sayfa === 'teklifler') {
    return (
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
        <Teklifler
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeri={menuyeDon}
          onIsEmriOlustu={tekliftenIsEmriAc}
        />
        {MesajlarBtn}{BildirimDrawer}
        {MobilChrome}
      </Suspense>
    );
  }

  if (sayfa === 'ihale') {
    return (
      <>
        <IhaleTakip
          kullanici={kullanici}
          canGor={canGor}
          canDuzenle={canDuzenle}
          onGeri={menuyeDon}
          onIhaleDetay={ihale => navigate({
            sayfa: 'ihaleDetay',
            secilenIhale: ihale,
            secilenIhaleArac: null,
          })}
        />
        {MobilChrome}
      </>
    );
  }

  return (
    <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>}>
      <AracListesi
        kullanici={kullanici}
        canGor={canGor}
        canDuzenle={canDuzenle}
        lokasyon={secilenLok || kullanici.lokasyon}
        onAracAc={aracAc}
        onGeriDon={menuyeDon}
        onMesajlar={() => navigate({ sayfa: 'mesajlar', secilenArac: null, secilenIhale: null, secilenIhaleArac: null })}
        okunmamisSayi={okunmamisSayi}
      />
      {MesajlarBtn}
      {MobilChrome}
    </Suspense>
  );
}

const mobileMenuLauncher = (open) => ({
  position: 'fixed',
  right: 14,
  bottom: 'calc(env(safe-area-inset-bottom, 0px) + 14px)',
  zIndex: 10050,
  minWidth: 62,
  height: 56,
  border: '1px solid rgba(255,255,255,.12)',
  background: 'rgba(15,17,21,.96)',
  color: '#fff',
  borderRadius: 18,
  padding: '7px 12px',
  boxShadow: open ? '0 10px 30px rgba(0,0,0,.28)' : '0 12px 30px rgba(0,0,0,.32)',
  backdropFilter: 'blur(18px)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 5,
  cursor: 'pointer',
  fontFamily: "'Barlow Condensed',sans-serif",
  fontWeight: 900,
  letterSpacing: .7,
  textTransform: 'uppercase',
  WebkitTapHighlightColor: 'transparent',
});

const mobileMenuLauncherLabel = () => ({
  fontSize: 13,
  lineHeight: 1,
});

const mobileMenuLauncherBadge = () => ({
  position: 'absolute',
  top: -7,
  left: -7,
  minWidth: 19,
  height: 19,
  padding: '0 5px',
  borderRadius: 99,
  background: '#e74c3c',
  color: '#fff',
  fontSize: 9,
  fontWeight: 800,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '2px solid var(--bg)',
});

const mobilePrimaryActions = () => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: 8,
  marginBottom: 14,
});

const mobilePrimaryActionBtn = (aktif) => ({
  position: 'relative',
  minHeight: 54,
  border: `1px solid ${aktif ? 'var(--ink)' : 'var(--border2)'}`,
  background: aktif ? 'var(--ink)' : 'var(--surface)',
  color: aktif ? '#fff' : 'var(--ink)',
  borderRadius: 14,
  cursor: 'pointer',
  padding: '5px 4px',
  display: 'grid',
  justifyItems: 'center',
  alignContent: 'center',
  gap: 4,
});

const mobilePrimaryActionLabel = (aktif) => ({
  fontFamily: "'Barlow Condensed',sans-serif",
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: .6,
  textTransform: 'uppercase',
  color: aktif ? '#fff' : 'var(--ink2)',
});

const mobileBadge = () => ({
  minWidth: 16,
  height: 16,
  padding: '0 5px',
  borderRadius: 99,
  background: '#e74c3c',
  color: '#fff',
  fontSize: 9,
  fontWeight: 800,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const mobileSheetWrap = () => ({
  position: 'fixed',
  inset: 'auto 0 0 0',
  zIndex: 10040,
  padding: '0 12px calc(env(safe-area-inset-bottom, 0px) + 12px)',
});

const mobileSheetCard = () => ({
  background: 'var(--bg)',
  borderRadius: '24px 24px 20px 20px',
  border: '1px solid var(--border2)',
  boxShadow: '0 -20px 48px rgba(0,0,0,.2)',
  padding: '18px 16px 16px',
});

const mobileCloseBtn = () => ({
  border: '1px solid var(--border2)',
  background: 'var(--surface)',
  color: 'var(--ink)',
  borderRadius: 999,
  padding: '8px 14px',
  cursor: 'pointer',
  fontFamily: "'Barlow Condensed',sans-serif",
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 1,
  textTransform: 'uppercase',
});

const mobileActionBtn = () => ({
  border: '1px solid var(--border2)',
  background: 'var(--surface)',
  borderRadius: 16,
  minHeight: 88,
  padding: '12px 14px',
  cursor: 'pointer',
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gap: 12,
  alignItems: 'center',
});

export default function App() {
  const musteriDosyaEslesme = window.location.pathname.match(/^\/musteri-dosya\/([^/]+)\/?$/);
  // Bu rota AuthProvider'ın dışındadır: müşteri araç dosyasını yalnızca
  // yöneticinin ürettiği, geri alınabilir paylaşım anahtarıyla görüntüler.
  if (musteriDosyaEslesme) {
    return <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>Dosya yükleniyor...</div>}><MusteriDosya token={musteriDosyaEslesme[1]} /></Suspense>;
  }
  if (process.env.NODE_ENV === 'development' && window.location.pathname === '/__preview-truck-parking') {
    return <Suspense fallback={null}><TruckParking userId="preview" userName="dkantar" onGeriDon={() => {window.location.href='/';}} /></Suspense>;
  }
  if (['/tir-park','/tir-park/'].includes(window.location.pathname)) {
    return <Suspense fallback={<div style={{background:'#142328',color:'#efb860',minHeight:'100vh',padding:32}}>Oyun yükleniyor…</div>}><PuzzleGuest game="parking" /></Suspense>;
  }
  if (window.location.pathname === '/oyun' || window.location.pathname === '/oyun/') {
    return <Suspense fallback={<div style={{ background: '#0b222c', color: '#c8dfdd', minHeight: '100vh', padding: 32 }}>Oyun yükleniyor…</div>}><PuzzleGuest /></Suspense>;
  }
  if (process.env.NODE_ENV === 'development' && window.location.pathname === '/__preview-zihin-molasi') {
    return <Suspense fallback={null}><ZihinMolasi userId="preview" userName="dkantar" onGeriDon={() => { window.location.href = '/'; }} /></Suspense>;
  }

  if (window.location.pathname === '/__preview-vehicle-detail') {
    return <Suspense fallback={null}><VehicleDetailPreview /></Suspense>;
  }

  if (window.location.pathname === '/__preview-vehicles') {
    return <Suspense fallback={null}><VehicleListPreview /></Suspense>;
  }

  if (window.location.pathname === '/__preview-dashboard') {
    return <DashboardPreview />;
  }

  if (window.location.pathname === '/__preview-mobile') {
    return <MobilePreviewRoute />;
  }

  return (
    <AuthProvider>
      <ThemeProvider>
        <AppIci />
      </ThemeProvider>
    </AuthProvider>
  );
}
